import React from 'react';

const PersonIcon = ({ active = false }) => {
  return (
    <svg id="person_outline" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path id="Path_6096" data-name="Path 6096" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_6097"
        data-name="Path 6097"
        d="M12,4a4,4,0,1,0,4,4A4,4,0,0,0,12,4Zm0,9c-2.67,0-8,1.34-8,4v3H20V17C20,14.34,14.67,13,12,13Z"
        fill={active ? '#58B9C1' : '#ededed'}
      />
    </svg>
  );
};

export default PersonIcon;
